import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Add, Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { nPercent } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'T. Doc Sun.', accessor: 'DocSubDescription' },
  { Header: 'Tipo Doc.', accessor: 'DocType' },
  { Header: 'Serie Doc.', accessor: 'U_SYP_MDSD' },
  { Header: 'Corr. Sun.', accessor: 'U_SYP_MDCD' },
  { Header: 'Num. SAP', accessor: 'DocNum' },
  { Header: 'Esta Doc.', accessor: 'DocStatus' },
  { Header: 'Cancelado', accessor: 'CANCELED' },
  { Header: 'Fec. Cont.', accessor: 'DocDate' },
  { Header: 'Fec. Vto.', accessor: 'DocDueDate' },
  { Header: 'Fec. Doc.', accessor: 'TaxDate' },
  { Header: 'Fec. Canc.', accessor: 'CancelDate' },
  { Header: 'Dirección', accessor: 'Address' },
  { Header: 'Dirección 2', accessor: 'Address2' },
  { Header: 'Vendedor', accessor: 'SlpCode' },
  { Header: '% Dsct.', accessor: 'DiscPrcnt' },
  { Header: 'Total Doc.', accessor: 'DocTotal' },
  { Header: 'Pagado', accessor: 'PaidToDate' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Receivable(props) {
  const classes = useStyles();

  const { businessPartner } = props;

  const [receivables, setReceivables] = useState([]);

  async function listReceivables() {
    let response = await wsFindBy(
      businessPartner.CardType === 'C'
        ? 'sap/business-partner/receivable'
        : 'sap/provider/receivable',
      'CardCode',
      businessPartner.CardCode
    );
    if (response.success) setReceivables(response.data);
  }

  useEffect(() => {
    listReceivables();
  }, []);
  return (
    <Card>
      <CardHeader icon>
        <CardIcon color={props.themeContext.buttonColor}>
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          Listado de cuentas por {businessPartner.CardType === 'C' ? 'cobrar' : 'pagar'}
        </h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          excelName={'Cuentas-por-cobrar-' + businessPartner.CardCode}
          defaultWidth={2500}
          indexRow={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]}
          widthRow={[
            80,
            120,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            100,
            300,
            300,
            300,
            100,
            100,
            100,
            5
          ]}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={receivables.map((item, i) => {
            return {
              num: i + 1,
              DocSubDescription: item.DocSubDescription, //DocSubType
              U_SYP_MDSD: item.U_SYP_MDSD,
              U_SYP_MDCD: item.U_SYP_MDCD,
              DocNum: item.DocNum,
              DocType: item.DocType === 'I' ? 'Artículo' : 'Servicio',
              CANCELED: item.CANCELED === 'Y' ? 'Si' : 'No',
              DocStatus: item.DocStatus === 'O' ? 'Abierto' : 'Cerrado',
              DocDate: item.DocDate,
              DocDueDate: item.DocDueDate,
              Address: item.Address,
              Address2: item.Address2,
              DiscPrcnt: nPercent(item.DiscPrcnt),
              DocTotal: item.DocTotal,
              PaidToDate: item.PaidToDate,
              SlpName: item.SlpName,
              TaxDate: item.TaxDate,
              CancelDate: item.CancelDate,
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
